export const getCompareSeriesRefId = (refId: string) => `${refId}-compare`;
